import type { VehicleLimitExceededType } from './VehicleLimitItem';

export class VehicleLimitApp {
    private vehicleLimits: VehicleLimitExceededType[] = [];

    public reset() {
        this.vehicleLimits = [];
    }

    public getVehicleLimits(): VehicleLimitExceededType[] {
        return this.vehicleLimits;
    }

    public addVehicleLimit(vehicleLimit: VehicleLimitExceededType): void {
        this.vehicleLimits.push(vehicleLimit);
    }

    public isAllVehicleLimitMet(): boolean {
        return this.vehicleLimits.every(vehicleLimit => !vehicleLimit.exceeded && !vehicleLimit.maxExceeded && !vehicleLimit.warningThresholdExceeded);
    }

    public getVehicleLimitsExceeded(): VehicleLimitExceededType[] {
        return this.vehicleLimits.filter(vehicleLimit => vehicleLimit.exceeded);
    }

    public getVehicleLimitsExceededOrClose(): VehicleLimitExceededType[] {
        return this.vehicleLimits.filter(vehicleLimit => vehicleLimit.exceeded || vehicleLimit.maxExceeded || vehicleLimit.warningThresholdExceeded);
    }

    public getVehicleLimitsSet(): VehicleLimitExceededType[] {
        return this.vehicleLimits.filter(vehicleLimit => vehicleLimit.limit);
    }

    public getDoubtReasons(): Record<string, string> {
        let reasons: Record<string, string> = {};
        let reasonsUniqArray = this.vehicleLimits.map(vehicleLimit => vehicleLimit.doubtReason).filter((e, i, self) => e && i === self.indexOf(e));
        let count = 1;
        for (let reason of reasonsUniqArray) {
            if (reason) {
                reasons[reason] = ''.padEnd(count, '*');
                count++;
            }
        }
        return reasons;
    }
}
